export default {
  ADD_APP(state, app) {
    state.apps = state.apps.concat(app);
  },
  DELETE_APP(state, deletedApp) {
    state.apps = state.apps.filter(app => app.name !== deletedApp.name);
  },
  SET_APPS(state, apps) {
    state.apps = [...apps];
  },
};
